import RoyalLife from "../../../../src/components/RenderImgs/royallifeImgs";
import * as React from 'react';
export default {
  RoyalLife,
  React
};